module.exports = __webpack_public_path__ + "static/media/multi-expectations-mobile.c98768df.png";